import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import JobsContext from "../context/JobsContext";
import { getAvailableJobs } from "../data/jobs";
import Icon from "./Icon";
import logo from "../img/werkenbijsmith-logo.svg";

function Navbar() {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();
    const headerRef = useRef(null);
    const toggleRef = useRef(null);
    const jobs = getAvailableJobs(useContext(JobsContext));

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => setOpen(false), [location]);
    useEffect(() => {
        if (!open) return;
        const onKey = (event) => {
            if (event.key === "Escape") {
                setOpen(false);
                toggleRef.current.focus();
            }
        };
        const onOutside = (event) => {
            if (!headerRef.current.contains(event.target)) setOpen(false);
        };
        document.addEventListener("keydown", onKey);
        document.addEventListener("pointerdown", onOutside);
        return () => {
            document.removeEventListener("keydown", onKey);
            document.removeEventListener("pointerdown", onOutside);
        };
    }, [open]);

    return (
        <header
            ref={headerRef}
            className={`site-header${scrolled ? " is-scrolled" : ""}${open ? " menu-open" : ""}`}
        >
            <a className="skip-link" href="#main-content">
                Ga naar inhoud
            </a>
            <div className="company-bar">
                <div className="site-container company-bar-inner">
                    <span>Samen bouwen aan morgen.</span>
                    <div>
                        <a href="https://smithsolar.nl/">
                            Smith Solar <Icon name="diagonal" />
                        </a>
                        <a href="https://smithtuinbouwtechniek.nl/">
                            Smith Tuinbouwtechniek <Icon name="diagonal" />
                        </a>
                    </div>
                </div>
            </div>
            <div className="site-container header-inner">
                <Link
                    to="/"
                    className="site-logo"
                    aria-label="Werken bij Smith — home"
                >
                    <img
                        src={logo}
                        alt="Werken bij Smith"
                        width="260"
                        height="75"
                    />
                </Link>
                <button
                    ref={toggleRef}
                    type="button"
                    className="menu-toggle"
                    aria-expanded={open}
                    aria-controls="main-navigation"
                    aria-label={open ? "Menu sluiten" : "Menu openen"}
                    onClick={() => setOpen(!open)}
                >
                    <span>{open ? "Sluiten" : "Menu"}</span>
                    <span className="menu-lines" aria-hidden="true">
                        <span />
                        <span />
                    </span>
                </button>
                <nav
                    id="main-navigation"
                    className={`main-navigation${open ? " is-open" : ""}`}
                    aria-label="Hoofdnavigatie"
                >
                    <Link to="/#over-smith" onClick={() => setOpen(false)}>
                        Werken bij Smith
                    </Link>
                    <Link to="/#vacatures" onClick={() => setOpen(false)}>
                        Vacatures{" "}
                        <span className="nav-count">{jobs.length}</span>
                    </Link>
                    <Link to="/#kennismaken" onClick={() => setOpen(false)}>
                        Kennismaken
                    </Link>
                    <Link
                        to="/#vacatures"
                        className="button button-orange nav-cta"
                        onClick={() => setOpen(false)}
                    >
                        Vind jouw baan <Icon />
                    </Link>
                    <div className="mobile-companies">
                        <a href="https://smithsolar.nl/">
                            Smith Solar <Icon name="diagonal" />
                        </a>
                        <a href="https://smithtuinbouwtechniek.nl/">
                            Smith Tuinbouwtechniek <Icon name="diagonal" />
                        </a>
                    </div>
                </nav>
            </div>
        </header>
    );
}
export default Navbar;
